import { Button, Col, Flex, Form, Row, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { CLINIC_STATUS_ENUM } from '../../appContants';
import { APP_TERMS } from '../../app-terms';
import { useUserLocale } from '../../hooks/useLocale';
import BasicCard from '../core/Cards/BasicCard';
import { formatDate } from '../../utils/date';
import EditInvoiceServicesForm from './EditInvoiceService';
import { logoVoxel } from '../imagepath';
import { useInvoiceUpdate } from '../../hooks/invoice/useInvoiceUpdate';
import { useState } from 'react';
import { mapInvoiceServicesToPayload } from '../../utils/invoice';

const { Paragraph, Title, Text } = Typography;

const InvoiceDetails = ({ data }) => {
  const navigate = useNavigate();
  const { userLocale } = useUserLocale();
  const [invoiceDetails, setInvoiceDetails] = useState(data);
  const { loading, status, updateInvoice } = useInvoiceUpdate();
  const [form] = Form.useForm();

  const handleSave = async () => {
    // Call api to enable the clinic
    try {
      const formData = form.getFieldsValue();
      const isInvalid =
        formData?.invoiceCaseServices?.filter((service) => {
          return !service?.amount;
        })?.length > 0;
      if (isInvalid) return;

      await updateInvoice({
        invoiceCaseServices: mapInvoiceServicesToPayload(
          formData?.invoiceCaseServices
        ),
      });
      navigate(-1);
    } catch (error) {
      console.log('error on save: ', error);
    }
  };

  const handleServicesChange = (services) => {
    setInvoiceDetails((prev) => ({
      ...prev,
      invoiceCaseServices: services,
    }));
  };

  return (
    <Form form={form} initialValues={invoiceDetails} layout="vertical">
      <Row gutter={[16, 16]} className="mt-3">
        <Col span={24}>
          <Flex justify="space-between">
            <img src={logoVoxel} alt="#" style={{ height: 80 }} />
            <Flex vertical justify="end" align="end">
              <Title level={5}>Voxel Readers</Title>
              <Text>15340 Larsen Street</Text>
              <Text>Overland Park Kansas 66221</Text>
              <Text>
                <Text strong>Call:</Text> +1 913-308-8994
              </Text>
              <Text>
                <Text strong>Email:</Text> info@voxelreaders.com
              </Text>
            </Flex>
          </Flex>
        </Col>
        <Col sm={24} md={12}>
          <BasicCard
            size="small"
            style={{ height: '100%' }}
            title={APP_TERMS.generic_to}
          >
            <Paragraph>{invoiceDetails?.clinicAdminName}</Paragraph>
            <Paragraph>{invoiceDetails?.clinicAdminEmail}</Paragraph>
            <Paragraph>{invoiceDetails?.clinicLocationTitle}</Paragraph>
          </BasicCard>
        </Col>
        <Col sm={24} md={12}>
          <BasicCard
            size="small"
            style={{ height: '100%' }}
            title={`${APP_TERMS.generic_invoice} ${APP_TERMS.generic_details}`}
          >
            <Paragraph>{invoiceDetails?.invoiceNo}</Paragraph>
            <Paragraph>
              {invoiceDetails?.createdAt &&
                formatDate(
                  invoiceDetails?.createdAt,
                  APP_TERMS.date_1_format,
                  userLocale
                )}
            </Paragraph>
          </BasicCard>
        </Col>
        <Col sm={24} md={12}>
          <BasicCard
            size="small"
            style={{ height: '100%' }}
            title={APP_TERMS.checks_payable_to}
          >
            <Paragraph>{APP_TERMS.app_title}</Paragraph>
          </BasicCard>
        </Col>
        <Col sm={24} md={12}>
          <BasicCard
            size="small"
            style={{ height: '100%' }}
            title={`${APP_TERMS.generic_due} ${APP_TERMS.generic_date}`}
          >
            <Paragraph>{APP_TERMS.due_date_alert}</Paragraph>
          </BasicCard>
        </Col>
        <Col span={24}>
          <Form.Item name="invoiceCaseServices">
            <EditInvoiceServicesForm onChange={handleServicesChange} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item className="mt-3">
        <Space>
          <Button
            key="enable"
            type="primary"
            htmlType="button"
            disabled={status === CLINIC_STATUS_ENUM.ENABLE}
            loading={loading}
            onClick={handleSave}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            disabled={loading}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
InvoiceDetails.propTypes = {
  data: PropTypes.object,
};
export default InvoiceDetails;
